<template>
  <PageList />
</template>
<script>
import PageList from './components/list'
export default {
  name: 'expo-meetingSet',
  components: { PageList },
}
</script>
